/**
 * ProtectedRoute — gate that bounces unauthenticated traffic to /login.
 *
 * Three states from `useAuth().user`:
 *   undefined → still booting; show a tiny "Checking session…" panel
 *   null      → confirmed unauthenticated; redirect to /login, preserving
 *               the intended destination so post-login lands us there
 *   <object>  → authenticated; render the wrapped children
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { CheckingFallback } from "@/pages/Login";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) return <CheckingFallback />;
  if (user === null) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return children;
}
